<template>
  <portal-modal
    size-class="!w-96"
    footer-class="!p-0"
    elevated
    class="z-[999999999999]"
    @close="$emit('dismiss')"
  >
    <template #header>
      <div
        class="font-bold text-xl"
        :class="variant === 'success' ? 'text-green-600' : 'text-red-600'"
      >
        {{ title }}
      </div>
    </template>
    <template #body>
      <div class="p-4 md:px-5 text-md">
        {{ text }}
      </div>
    </template>
    <template #footer>
      <button
        class="flex items-center justify-center w-full text-sm text-white p-4 rounded-b-lg cursor-pointer"
        :class="variant === 'success' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'"
        type="button"
        @click.prevent="$emit('dismiss')"
      >
        {{ ok }}
      </button>
    </template>
  </portal-modal>
</template>
<script>
import PortalModal from "../UI/PortalModal.vue"

export default {
  name: "PortalSimpleAlert",
  components: { PortalModal },

  emits: ["dismiss"],

  props: {
    text: { required: true, type: String },
    ok: { required: false, type: String, default: "DISMISS" },
    title: { required: false, type: String, default: "Alert" },
    variant: { required: false, type: String, default: "error" },
  },
}
</script>
